import { PersistentFormControl, PersistentFormGroup } from '@utility/persistent-forms';
import { maxLengthValidator, notWhitespaceValidator } from '@utility/utility.validators';
import { StipendVisitsFormGroup } from '../stipend-visits/stipend-visits.form';

export class SiteServicesSpecificServicesFormGroup extends PersistentFormGroup<{
    travelSupportControl: PersistentFormControl<boolean | null>;
    reimbursementControl: PersistentFormControl<boolean | null>;
    stipendControl: PersistentFormControl<boolean | null>;
    otherControl: PersistentFormControl<boolean | null>;
    otherDetails: PersistentFormControl<string | null>;

    stipendVisits: StipendVisitsFormGroup;
}> {
    constructor() {
        super(
            {
                travelSupportControl: new PersistentFormControl<boolean | null>(null),
                reimbursementControl: new PersistentFormControl<boolean | null>(null),
                stipendControl: new PersistentFormControl<boolean | null>(null),
                otherControl: new PersistentFormControl<boolean | null>(null),
                otherDetails: new PersistentFormControl<string | null>(null, [
                    notWhitespaceValidator(),
                    maxLengthValidator(500),
                ]),

                stipendVisits: new StipendVisitsFormGroup(),
            },
            [
                (control) => {
                    const formGroup = control as SiteServicesSpecificServicesFormGroup;
                    const value = formGroup.getRawValue(); // travelsupportcontrol can be disabled so need to use .getRawValue() instead of .value, otherwise it will show error that an option is required when no other option than travel is selected
                    if (!value) return null;

                    if (!value.travelSupportControl && !value.stipendControl && !value.reimbursementControl)
                        return { required: 'Option is required' };
                    return null;
                },
            ]
        );
    }
}
